/** Roles de usuario ICJEME (deben coincidir con el backend). */
export const ROLE_PASTOR = "pastor";
export const ROLE_ADMIN = "administrador";
export const ROLE_PASTORA = "pastora";
export const ROLE_SUPERVISOR = "supervisor";
export const ROLE_LIDER = "lider";
export const ROLE_SECRETARIO = "secretario";

export const REGISTER_ROLES = [
  ROLE_PASTOR,
  ROLE_ADMIN,
  ROLE_SUPERVISOR,
  ROLE_LIDER,
  ROLE_SECRETARIO,
];

export const ROLES_REQUIRING_MEMBER_ID = [
  ROLE_PASTOR,
  ROLE_ADMIN,
  ROLE_SUPERVISOR,
  ROLE_LIDER,
  ROLE_SECRETARIO,
];

export function isFullAccess(user) {
  const r = user?.role;
  return r === ROLE_PASTOR || r === ROLE_ADMIN || r === ROLE_PASTORA;
}

export function isSupervisor(user) {
  return user?.role === ROLE_SUPERVISOR;
}

export function isLider(user) {
  return user?.role === ROLE_LIDER;
}

export function isSecretario(user) {
  return user?.role === ROLE_SECRETARIO;
}

/** Líder o secretario de célula (mismos permisos operativos). */
export function isCellStaff(user) {
  return isLider(user) || isSecretario(user);
}

export function isPastorOrSupervisor(user) {
  return isFullAccess(user) || isSupervisor(user);
}

export function isPastorSupervisorOrCellStaff(user) {
  return isPastorOrSupervisor(user) || isCellStaff(user);
}

export function canWriteMembers(user) {
  return isFullAccess(user) || isSupervisor(user) || isCellStaff(user);
}

export function canManageOrg(user) {
  return isFullAccess(user);
}

export function roleLabel(role) {
  const labels = {
    [ROLE_PASTOR]: "Pastor",
    [ROLE_PASTORA]: "Pastora",
    [ROLE_ADMIN]: "Administrador",
    [ROLE_SUPERVISOR]: "Supervisor",
    [ROLE_LIDER]: "Líder de célula",
    [ROLE_SECRETARIO]: "Secretario de célula",
  };
  return labels[role] || role || "—";
}

export function isTrashAdminUser(user) {
  return user?.is_trash_admin === true;
}

/** Pestaña Papelera global: pastor/administrador o pastor con is_trash_admin. */
export function canAccessGlobalTrash(user) {
  return isFullAccess(user) || (user?.role === ROLE_PASTOR && isTrashAdminUser(user));
}

/** Ver papelera de células/miembros (borrado lógico). */
export function canViewCellsTrash(user) {
  return canAccessGlobalTrash(user);
}

/** Restaurar desde papelera de células o global. */
export function canRestoreFromTrash(user) {
  return isFullAccess(user);
}

/** Eliminar definitivamente (requiere contraseña en API). */
export function canPermanentDeleteFromTrash(user) {
  return isFullAccess(user);
}

/**
 * Herramientas Administrativas (respaldo/restauración).
 * Solo administrador, pastor o pastora.
 */
export function canAccessAdminTools(user) {
  return isFullAccess(user);
}

/** Clave sessionStorage del token de desbloqueo (una vez por sesión de navegador). */
export const ADMIN_TOOLS_UNLOCK_STORAGE_KEY = "icjeme_admin_tools_token";

export function clearAdminToolsUnlock() {
  try {
    sessionStorage.removeItem(ADMIN_TOOLS_UNLOCK_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function getAdminToolsUnlockToken() {
  try {
    return sessionStorage.getItem(ADMIN_TOOLS_UNLOCK_STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

export function setAdminToolsUnlockToken(token) {
  try {
    if (token) sessionStorage.setItem(ADMIN_TOOLS_UNLOCK_STORAGE_KEY, token);
    else sessionStorage.removeItem(ADMIN_TOOLS_UNLOCK_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
